(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/tickets-wheel.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/tickets-wheel.js');
"use strict";

let lastSnapped;
setGlobal('svs.tickets.play.components.TicketWheel', React.memo(_ref => {
  let {
    accessibleText,
    children,
    onHandleNumberChanged,
    handleGamePay
  } = _ref;
  const {
    useRef,
    useState
  } = React;
  const containerRef = useRef(null);
  const [activeFocus, setActiveFocus] = useState(null);
  const selectSnappedElement = svs.tickets.play.utils.utils.selectSnappedElement;
  const lazySelected = _.debounce(checkSnapped, 10);
  return React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      handleGamePay();
    }
  }, React.createElement("div", {
    className: "ticket-wheel-container",
    onScroll: lazySelected,
    ref: containerRef
  }, React.createElement("div", {
    className: "ticket-wheel-fill-before"
  }), React.createElement("fieldset", {
    className: "ticket-wheel-fieldset"
  }, React.createElement("legend", {
    className: "ticket-wheel-legend"
  }, accessibleText), children.map((child, index) => {
    const {
      number,
      chosen
    } = child.props;
    return React.createElement(React.Fragment, {
      key: index
    }, React.createElement("input", {
      "aria-label": "Lott ".concat(number, " av ").concat(children.length),
      checked: chosen,
      className: "qa-ticket-sunfeather-radio hide-radio",
      name: "ticket-skin-radio",
      onBlur: () => {
        setActiveFocus(null);
      },
      onChange: () => {
        onHandleNumberChanged(number);
      },
      onFocus: () => {
        setActiveFocus(number);
      },
      type: "radio",
      value: number
    }), React.createElement("label", {
      className: "wheel-item-wrapper",
      key: "wheel_child_".concat(index)
    }, React.cloneElement(child, {
      hasFocus: activeFocus === number
    })));
  })), React.createElement("input", {
    className: "qa-ticket-sunfeather-input",
    name: "submit-button",
    style: {
      opacity: 0,
      width: 0,
      height: 0
    },
    tabIndex: "-1",
    type: "submit"
  }), React.createElement("div", {
    className: "ticket-wheel-fill-after"
  })));

  function checkSnapped() {
    const selected = selectSnappedElement(containerRef.current, 'wheel-item-wrapper');
    if (selected && selected !== lastSnapped) {
      lastSnapped && lastSnapped.classList.remove('snapped');
      selected && selected.classList.add('snapped');
      lastSnapped = selected;
      onHandleNumberChanged(parseInt(selected.firstElementChild.dataset.ticketNumber, 10));
    }
  }
}));

 })(window);